__turbopack_context__.v({
  "content": "Dashboard-module-scss-module__rww2xa__content",
  "designRow": "Dashboard-module-scss-module__rww2xa__designRow",
  "designRowSecondary": "Dashboard-module-scss-module__rww2xa__designRowSecondary",
  "designTable": "Dashboard-module-scss-module__rww2xa__designTable",
  "discover": "Dashboard-module-scss-module__rww2xa__discover",
  "hero": "Dashboard-module-scss-module__rww2xa__hero",
  "heroPlan": "Dashboard-module-scss-module__rww2xa__heroPlan",
  "heroProfile": "Dashboard-module-scss-module__rww2xa__heroProfile",
  "profileChip": "Dashboard-module-scss-module__rww2xa__profileChip",
  "profileUpgrade": "Dashboard-module-scss-module__rww2xa__profileUpgrade",
  "root": "Dashboard-module-scss-module__rww2xa__root",
  "skeleton": "Dashboard-module-scss-module__rww2xa__skeleton",
  "teaser": "Dashboard-module-scss-module__rww2xa__teaser",
  "teaserLink": "Dashboard-module-scss-module__rww2xa__teaserLink",
});
